<template>
  <div class="person-info">
    <section v-loading="loading">
      <!-- 选手详情 -->
      <div class="template-title">参赛人员信息</div>
      <div class="header-info">
        <player-info class="player-wrapper" />
        <p v-if="auditTitle.show" :style="{color: auditTitle.color}">{{auditTitle.text}}</p>
      </div>
      <!--  上传材料要求要求-->
      <div class="template-title">竞赛材料提交要求</div>
      <div class="template-description" v-html="activityDesc"></div>
      <div
        class="template-wrapper"
        v-for="(template, index) in sections"
        :key="index"
      >
        <div class="title-wrapper">
          <p class="template-title">{{template ? template.title : ''}}</p>
          <!-- <img
            v-if="needShowGuide(template)"
            src="@/assets/images/icon_question.png"
            class="question-mark"
            @click="showGuide(template)"
          />
          <p
            v-if="needShowGuide(template)"
            class="template-tips"
            @click="showGuide(template)"
          >{{ template && template.type === 'ppt' ? '我想在ppt中插入视频文件，该如何操作？' : '如何把教学视频转为MP4格式？' }}</p> -->
        </div>
        <p
          class="description"
          :class="{'template-description': template && template.type !== 'description', 'template-title' : template && template.type === 'description'}"
          v-html="filterDescMark(template ? template.desc : '')"
        ></p>
        <div class="template-file-list">
          <file-uploader
            :canDownload="download"
            :fileDesc="template ? template.desc : ''"
            :rejectFileIdList="rejectFileIdList"
            :type="template ? template.type : ''"
            v-model="template.materials"
            :status="status"
            :activityId="activity_id"
            :playerId="player_id"
            :typesItemIndex="index"
            :attachmentId='template.attachmentId'
            :isUploadingMode='true'
            @downloadAttachment="downloadAttachment"
            @itemUploadSuccess="itemUploadSuccess"
            @deleteItem="deleteItem"
          ></file-uploader>
        </div>
      </div>
    </section>
    <section class="info-warpper">
      <p>注意事项：</p>
      <p>1.标题与附件为必填项；</p>
      <p>2.根据格式不同需上传相应格式的附件，若格式错误将无法成功上传；</p>
      <p>3.竞赛材料一经提交，将进入材料审核流程，期间文件不可更改。</p>
    </section>
    <footer>
      <el-button
        type="primary"
        v-if="status==='refuse'"
        @click="submit"
        :disabled="btnActive"
        class="btn-confirm"
      >提交修改
      </el-button>
      <el-button
        type="primary"
        @click="submit"
        v-if="status==='uncommitted'"
        class="btn-confirm"
        :disabled="btnActive"
      >
        提交
      </el-button>
    </footer>
    <div
      class="audit-record"
      v-if="shouldShowAudit"
    >
      <p class="audit-record-title">审核记录</p>
      <div
        class="audit-wrapper"
        v-for="(record, index) in audit_record"
        :key="index"
        :class="{'audit-wrapper--first-child': index === 0 }"
      >
        <div
          class="icon-warpper"
          :class="shouldShowIconWidth(record.status)"
        ></div>
        <div class="content">
          <div style="display: flex">
            <p
              style="margin-right: 5px"
              class="audit-time"
            >审核时间:</p>
            <p class="audit-time">{{record.time}}</p>
          </div>
          <div style="display: flex">
            <p style="margin-right: 5px">审核结果：</p>
            <span
              class="audit-result"
              :class="{'reject': record.status === 'rejected'}"
            >{{record.statusTxt}}</span>
          </div>
          <div style="display: flex">
            <p class="audit-recommend">审核意见：</p>
            <p
              class="audit-recommend"
              style="flex: 1"
              v-html="record.opinion ? record.opinion.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;') : ''"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FileUploader from '@/components/MaterialUploader'
import PlayerInfo from '@/components/player-info/index.vue'
import { getMaterialRequired, saveMaterial, submitMaterial, getMaterialDetailV3, getAuditRecord, getCourseWareDetails } from '../service/contestantInfo.js'
import { processingDefaultMaterial, processingLocalDataToService, processingDetailWithDefaultData, uploadFailedProcessingData, MATERIAL_TYPE, removeSpecialString, descriptionIsVideo } from '../model/processingData'
import download from '../assets/downloader'
import auditStatus from '../model/auditStatus'
import guideFileUrls from '../model/guideFileUrls'

export default {
  components: {
    FileUploader,
    PlayerInfo
  },
  data () {
    return {
      btnActive: false,
      PersonInfo: {
        union: { title: '' },
        name: '',
        number: '',
        telephone: '',
        gender: 'male'
      },
      loading: false,
      status: '',
      sections: [],
      activity: '',
      download: false,
      position: '',
      player_id: 0,
      activity_id: 0,
      audit_record: [],
      rejectFileIdList: [],
      activityDesc: '',
      sponsor: ''
    }
  },
  created () {
    this.PersonInfo = JSON.parse(localStorage.getItem('PersonInfo')).user
    this.activity_id = localStorage.getItem('activity_id')
    this.player_id = this.PersonInfo.id
    this.getfileList()
    this._getAuditRecord()
    if (this.PersonInfo.union === '' || !this.PersonInfo.union || this.PersonInfo.union === null) {
      let union = { title: '暂无' }
      let PersonInfo = this.PersonInfo
      PersonInfo.union = union
    }
    this.position = this.PersonInfo.union.province.name
    // 获取活动信息
    this.fetchActivity()
  },
  computed: {
    auditTitle () {
      switch (this.status) {
        case 'pending':
          return {show: true, text: '审核中...', color: '#f1c40f'}
        case 'refuse':
          return {show: true, text: '已驳回', color: '#F04037'}
        case 'approved':
          return {show: true, text: '已通过', color: '#68BF7B'}
        default:
          return {show: false, text: '', color: ''}
      }
    },
    shouldShowIconWidth () {
      return function (status) {
        if (status === auditStatus.REJECTED) {
          return 'icon-reject'
        } else {
          return 'icon-approve'
        }
      }
    },
    shouldShowAudit () {
      return this.audit_record.length > 0 && this.status !== auditStatus.PENDING
    }
  },
  methods: {
    getfileList () {
      // 获取材料要求
      getMaterialRequired(this.activity_id).then((res) => {
        this.loading = false
        const descList = res.data.filter(item => item.file_type === MATERIAL_TYPE.DESCRIPTION)
        this.activityDesc = descList.length > 0 ? descList[0].desc.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;') : ''
        this.sections = processingDefaultMaterial(res.data)
        // 获取材料上传详情信息
        this.getMaterialDetail()
      })
    },
    downloadAttachment (type, path, file) {
      if (this.download) {
        let url = path
        if (file && file.name) {
          url = this.encodeFileNameInUrl(path, file.name)
        }
        download(1, url, '')
      }
    },
    encodeFileNameInUrl (url, filename) {
      if (!filename || url.indexOf(filename) === -1) {
        return url
      }
      let encodeFileName = encodeURIComponent(filename)
      return url.replace(filename, encodeFileName)
    },
    _getCourseWareDetails () {
      getCourseWareDetails(this.activity_id, this.player_id).then(res => {
        if (res.data && res.data.is_selected && res.data.id) {
          this.$router.push(`/${this.activity_id}/${this.player_id}/CourseWareDetail`)
        }
      })
    },
    fetchActivity () {
      let activityInfo = JSON.parse(localStorage.getItem('PersonInfo')).activity
      this.activity = activityInfo.title
      if (activityInfo.sponsors && activityInfo.sponsors.length > 0) {
        this.sponsor = '主办单位：' + activityInfo.sponsors.map(item => item.title).join('、')
      } else {
        this.sponsor = '主办单位：' + activityInfo.union.title
      }
      this._getCourseWareDetails()
    },
    // 获取上传资料详情
    getMaterialDetail () {
      getMaterialDetailV3(this.activity_id).then((resDetail) => {
        this.loading = false
        // 总状态
        this.status = resDetail.data.audit_status
        if (resDetail.data.rejected_material_ids) {
          // 驳回的文件id列表
          this.rejectFileIdList = resDetail.data.rejected_material_ids.split(',').map(item => Number(item))
        }
        if (this.status === auditStatus.APPROVED) {
          this.download = true
          this.$router.push(`/DownloadAll`)
        }
        this.content = resDetail.data.content
        this.$store.dispatch(`commitMaterialsStatus`, this.status)
        this.sections = processingDetailWithDefaultData(this.sections, resDetail.data.detail || [], resDetail.data.audit_status)
        // console.log(this.sections, 'test1')
      })
    },
    itemUploadSuccess (typesItemIndex, fileItemIndex, index, type) {
      console.log(typesItemIndex, fileItemIndex, index, type)
    },
    deleteItem (typesItemIndex, fileItemIndex, index, type) {
      let fileList = this.sections.slice(0)
      let params = processingLocalDataToService(fileList, typesItemIndex, fileItemIndex, index, this.activity_id, this.PersonInfo.id, 'delete', this.rejectFileIdList)
      if (params && params.errorType === 'unRejectedFile') {
        this.$alert(params.errorMsg, '提示')
        return
      }
      if (params && params.errorType === 'uncomplete') {
        return
      }
      saveMaterial(params, this.PersonInfo.id, this.activity_id).then((res) => {
        this.btnActive = false
        if (res.status === 'success') {
          if (res.data) {
            this.sections = processingDetailWithDefaultData(this.sections, [res.data])
          }
        } else {
          console.log('saveloadFailed', res.msg)
          this.saveFailed(fileList, typesItemIndex, fileItemIndex, 'delete')
        }
      }).catch((e) => {
        this.saveFailed(fileList, typesItemIndex, fileItemIndex, 'delete')
        console.log('saveloadFailed', e)
        this.btnActive = false
      })
    },
    saveFailed (fileList, typesItemIndex, fileItemIndex, opt) {
      uploadFailedProcessingData(fileList, typesItemIndex, fileItemIndex)
      let msg = '上传失败，请重新上传！'
      if (opt === 'delete') {
        msg = '删除失败，请刷新当前页面后重试！'
      } else {
        msg = '上传失败，请重新上传！'
      }
      this.$alert(msg, '提示')
    },
    submit () {
      // 验证参数是否符合提交要求
      if (!this.validate()) {
        return
      }
      // 提交材料
      let msg = '提交后文件不可更改，请慎重提交'
      let dangerouslyUseHTMLString = false
      if (this.status === auditStatus.REFUSED) {
        dangerouslyUseHTMLString = true
        msg = '<span>请确认所有驳回文件已更新</span><br><span>提交后不可更改，请慎重提交</span>'
      }
      this.$alert(msg, '提示', {
        confirmButtonText: '确定',
        showCancelButton: true,
        dangerouslyUseHTMLString: dangerouslyUseHTMLString,
        callback: action => {
          if (action === 'confirm') {
            // 组装请求需要的参数
            this.btnActive = true
            // 上传文件时已经将数据都提交服务器，所以点击提交按钮时不需要将所有的文件信息再提交一遍，而且提交接口中只需要选手id和活动id，不需要其他参数。
            submitMaterial(this.PersonInfo.id, this.activity_id).then((res) => {
              this.btnActive = false
              if (res.status === 'success') {
                this.$alert('您已成功上传竞赛材料，工作人员会尽快开始审核，审核结果将会以短信的形式发送给您，请您注意查收！', '温馨提示', { confirmButtonText: '知道了', dangerouslyUseHTMLString: true })
                this.getfileList()
                this.getMaterialDetail()
                localStorage.setItem('refuseAndUpdateFiles', '')
              } else {
                this.$alert(res.msg, '提示')
              }
            }).catch((e) => {
              this.$alert(e, '提示')
              this.btnActive = false
            })
          }
        }
      })
    },
    validate () {
      let validateData = this.sections
      // 验证
      let flag = true
      for (let i in validateData) {
        if (validateData[i].type !== MATERIAL_TYPE.DESCRIPTION) {
          for (let j in validateData[i].materials) {
            let material = validateData[i].materials[j]
            if (material && material.title && material.title.length > 100) {
              let message = '教学设计、教学展示附件标题超长'
              let title = `教学设计、教学展示附件 第` + (Number(j) + 1) + `课时标题超长`
              this.$alert(title, message, {
                confirmButtonText: '确定',
                callback: action => { }
              })
              flag = false
              return false
            }
            if (validateData[i].type === MATERIAL_TYPE.RE_THINK && material.files[0].remoteFile.path === '') {
              let title = '请确认是否正确上传教学反思'
              let message = `消息提示(教学反思)`
              this.$alert(title, message, {
                confirmButtonText: '确定',
                callback: action => { }
              })
              flag = false
              return false
            }
            if (validateData[i].type === MATERIAL_TYPE.VIDEO && material.files[0].remoteFile.path === '') {
              let title = '请确认是否正确上传教学视频'
              let message = `消息提示(教学视频)`
              this.$alert(title, message, {
                confirmButtonText: '确定',
                callback: action => { }
              })
              flag = false
              return false
            }
            if (validateData[i].type === MATERIAL_TYPE.WORD && material.files[0].remoteFile.path === '') {
              const sectionTitle = validateData[i] && validateData[i].title ? String(validateData[i].title) : ''
              const sectionKey = sectionTitle.replace(/^上传/, '').replace(/附件$/, '').trim()
              let title = `请确认是否正确上传${sectionKey || '必须选项'}的文档附件`
              let message = `消息提示(其他文档附件)`
              this.$alert(title, message, {
                confirmButtonText: '确定',
                callback: action => { }
              })
              flag = false
              return false
            }
            if (validateData[i].type === MATERIAL_TYPE.PPT && material && material.title === '') {
              this.$alert('请确认是否已经填写第' + (Number(j) + 1) + '个课时的标题', `消息提示(教学设计、教学展示附件)`, {
                confirmButtonText: '确定',
                callback: action => { }
              })
              flag = false
              return false
            }
            if (validateData[i].type === MATERIAL_TYPE.PPT && material.files[0].remoteFile.path === '') {
              this.$alert('请确认是否正确上传第' + (Number(j) + 1) + '个课时的ppt附件', `消息提示(教学设计、教学展示附件)`, {
                confirmButtonText: '确定',
                callback: action => { }
              })
              flag = false
              return false
            }
            // fixme: 专门给江苏南大只上传ppt做的修改 【409-416 完事以后放开注释】
            if (validateData[i].type === MATERIAL_TYPE.PPT && material.files[1].remoteFile.path === '') {
              this.$alert('请确认是否正确上传第' + (Number(j) + 1) + '个课时的pdf附件', `消息提示(教学设计、教学展示附件)`, {
                confirmButtonText: '确定',
                callback: action => { }
              })
              flag = false
              return false
            }
            // 如果当前待提交数据中，文件已上传但是没有对应的id的话，则视为本地数据（服务器不存在该条数据记录），则刷新页面从服务器获取最新数据
            if (material && (material.id === '' || material.id === null || material.id === undefined)) {
              let message = '提示'
              let title = `抱歉，您有附件未保存成功，请刷新页面重试`
              this.$alert(title, message, {
                confirmButtonText: '确定',
                callback: action => {
                  this.getfileList()
                  this.fetchActivity()
                }
              })
              flag = false
              return false
            }
          }
        }
      }
      return flag
    },
    back () {
      this.$router.go(-1)
      // 返回
    },
    _getAuditRecord () {
      getAuditRecord(this.player_id, this.activity_id).then(res => {
        this.audit_record = res.data.map(record => {
          return {
            time: record.create_time,
            opinion: record.content,
            statusTxt: record.audit_status === auditStatus.REJECTED ? '驳回' : '通过',
            status: record.audit_status
          }
        })
      })
    },
    filterDescMark (desc) {
      if (!desc) { return '' }
      return removeSpecialString(desc)
    },
    needShowGuide (file) {
      if (!file) {
        return false
      }
      return file.type === MATERIAL_TYPE.PPT || (file.desc && descriptionIsVideo(file.desc))
    },
    showGuide (file) {
      let pathUrl = ''
      if (file.type === MATERIAL_TYPE.PPT) { // PPT
        pathUrl = guideFileUrls.PPT
      } else if ((file.desc && descriptionIsVideo(file.desc))) { // Video
        pathUrl = guideFileUrls.VIDEO
      }
      if (pathUrl) {
        window.open(pathUrl, '__blank')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.person-info {
  width: 100%;
  max-width: 686px;
  margin: 0 auto;
  padding-top: 25px;
}
.header-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  > p {
    font-size: 28px;
    font-weight: bold;
    margin-top: 26px;
  }
}
.template-wrapper {
  margin-bottom: 38px;
}

.title-wrapper {
  display: flex;
  align-items: center;
}

.template-title {
  font-size: 20px;
  font-weight: 600;
  color: #4E5A73;
  padding-left: 10px;
  position: relative;
  &::before {
    content: '';
    width: 6px;
    height: 20px;
    background: #F04037;
    position: absolute;
    left: 0;
    top: 5px;
  }
}

.player-wrapper {
  margin: 26px 0;
}

.template-description {
  font-size: 15px;
  font-weight: 400;
  color: #4E5A73;
  line-height: 30px;
}

.template-tips {
  padding-left: 3px;
  font-size: 16px;
  color: #2440B3;
  margin: 0px;
  cursor: pointer;
}

.description {
  width: 100%;
  word-break: break-all;
}
.el-upload-list__item .el-icon-close-tip {
  display: none !important;
}
.mt-tree {
  margin-top: 30px;
}
.mt-one {
  margin-top: 10px;
}
.el-upload-list__item-name {
  width: 120px;
}
.el-card {
  border: none !important;
}
.el-card__body {
  padding: 10px;
}
.el-textarea.is-disabled .el-textarea__inner {
  /* border: none!important; */
  background: #fff !important;
  color: #f56c6c !important;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-weight: 600 !important;
}
</style>

<style lang="scss" scoped>
.explain {
  margin: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bold {
  display: inline-block;
  font-weight: 600;
  font-size: 16px;
  color: #000;
  border-bottom: 5px solid #c12b20;
}
.line-right {
  display: inline-block;
  width: 4px;
  height: 80px;
  background: #ccc;
  margin-top: 20px;
}
.bg {
  /* background: #6c7dbf; */
  padding-top: 15px;
  display: flex;
  color: #999;
  padding-bottom: 20px;
  font-size: 15px;
}
.footer-menu {
  margin-bottom: 20px;
  margin-top: 20px;
  text-align: left;
  padding-left: 20px;
  padding-bottom: 30px;
}
.result-text .result {
  font-weight: 600;
  color: #f56c6c;
  font-size: 18px;
}
.result-text .txt_left .result-pending {
  font-weight: 600;
  color: rgb(143, 145, 22);
  font-size: 18px;
}
.result-text .result-pro {
  font-weight: 600;
  color: rgb(25, 139, 25);
  font-size: 18px;
}
.flex {
  display: flex;
  flex-wrap: wrap;
}
input:disabled {
  border: none;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  height: 20px;
  padding: 0 0px;
}
.txt_left {
  text-align: left;
  color: #999;
}
.course-index {
  display: flex;
  font-size: 12px;
  color: #999;
  margin-top: 20px;
}
.list-title {
  margin-top: 30px;
  margin-bottom: 20px;
}
.list-style {
  /* width:18%; */
  /* width: 280px; */
  margin-left: 10px;
  /* margin-top:30px */
}
.list-style:first-child {
  margin-left: 0px;
}
.explain h2 {
  font-size: 16px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.txt_left span {
  font-size: 16px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 30px;
}
.title {
  margin-top: 20px;
  text-align: left;
  color: #333333;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 20px;
}
.el-card.is-always-shadow {
  box-shadow: none;
}
.file_name_input {
  width: 88% !important;
  display: flex !important;
  /* margin-left: 20px; */
  -webkit-appearance: none;
  background-color: #ffffff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  font-size: inherit;
  height: 40px;
  line-height: 20px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #dcdfe6;
}
input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #dcdfe6;
}
input::-moz-placeholder,
textarea::-moz-placeholder {
  color: #dcdfe6;
}
input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #dcdfe6;
}
input[type="text"]:focus {
  border: 1px solid #c12b20;
}
.btn {
  width: 132px;
  height: 40px;
  font-size: 16px;
}
.tishi {
  font-size: 16px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 22px;
  display: block;
  margin-top: 40px;
}
.line-item {
  /* padding: 1em; */
  border-bottom: 1px dashed transparent;
  background: linear-gradient(white, white) padding-box,
    repeating-linear-gradient(-45deg, #ccc 0, #ccc 0.45em, white 0, white 0.9em);
}
section > :nth-child(4) {
  padding-bottom: 20px;
  // border-bottom: 1px solid #ccc;
}
.line-item:last-child {
  border-bottom: none;
}
.desc {
  display: block;
  margin-top: 15px;
  text-align: left;
  font-size: 16px;
  color: #3e3e3e;
  font-weight: 600;
}
.upload-div {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.zip-wrapper {
  display: flex;
  .zip-descript {
    width: 200px;
    height: 120px;
    margin-top: 20px;
    color: #999999;
    font-size: 16px;
  }
}
.audit-record {
  padding: 0 20px 20px;
  box-sizing: border-box;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
  .audit-record-title {
    font-size: 20px;
    color: #333;
    line-height: 24px;
    margin-bottom: 10px;
  }
  .audit-wrapper {
    background-color: #f9f9f9;
    border-radius: 3px;
    padding: 10px;
    box-sizing: border-box;
    font-size: 16px;
    color: #a2a2a2;
    margin-bottom: 10px;
    opacity: 0.6;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .content {
      flex: 1;
    }
    .icon-warpper {
      flex-shrink: 0;
      width: 168px;
      height: 64px;
      margin-right: 20px;
      margin-left: 10px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }
    .icon-reject {
      background-image: url("../assets/images/rejected.png");
    }
    .icon-approve {
      background-image: url("../assets/images/approve.png");
    }
  }
  .audit-wrapper--first-child {
    opacity: 1;
  }
  p {
    margin: 0;
  }
  .audit-result {
    color: #00c200;
  }
  .audit-result.reject {
    color: #cb3019;
  }
  .audit-time {
    color: #a2a2a2;
    margin-bottom: 4px;
  }
  .audit-recommend {
    color: #989898;
    margin-top: 4px;
  }
}
.template-file-list {
  width: 100%;
}
.info-warpper {
  color: #666;
  line-height: 24px;
  font-size: 15px;
  font-weight: 400;
  color: #4E5A73;
  line-height: 30px;
  border-top: 1px dotted #DCDFE6;
  padding-top: 30px;
}
footer {
  text-align: left;
  padding-bottom: 30px;
}

.btn-confirm {
  width: 180px;
  height: 40px;
  background: #F04037;
  border-color: #F04037;
  border-radius: 4px;
  font-size: 15px;
}

.custom-dialog-body {
  width: 440px;
  // padding: 23px 50px 0px 50px;
  .default-text {
    font-size: 18px;
    color: #888888;
  }
}
.dialog-close {
  width: 36px;
  height: 36px;
  position: absolute;
  top: 10px;
  right: 20px;
  /// left: calc(100% - 40px);
}
.dialog-title {
  display: block;
  text-align: center;
  font-size: 22px;
  padding-bottom: 26px;
  color: #3a3a3a;
  border-bottom: 1px solid rgba(190, 190, 190, 1);
}
.browser-frame {
  background-size: 100% 100%;
  padding: 20px 0 30px 0;
}
.video {
  height: 300px;
}
/deep/ .el-dialog {
  width: 480px;
}
/deep/ .el-dialog__body {
  padding: 0px 20px;
  width: 440px;
}
</style>
<style>
.el-message-box {
  width: 500px;
}
.question-mark {
  width: 16px;
  height: 16px;
  margin: 0px 0px 3px 15px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/PersonInfo.vue